import React from 'react';
import { PATH_NAMES } from '~/ocab-services/nursery/constants';
import { VIRTUAL_EDIT_PROGRESS_BAR_ITEMS, VIRTUAL_PROGRESS_BAR_ITEMS } from '~/ocab-services/nursery/config/progress-bar-items.config';
import { services } from '~/ocab-services/services.constant';

export const config = {
  v1: {
    searchResultDescription: 'If you\'re booking a virtual appointment, you can book at any shop or select one nearer to you.',
  },
  v2: {
    appointment: {
      name: 'Nursery Advice',
    },
    PROGRESS_BAR_ITEMS: VIRTUAL_PROGRESS_BAR_ITEMS,
    EDIT_PROGRESS_BAR_ITEMS: VIRTUAL_EDIT_PROGRESS_BAR_ITEMS,
    editMode: {
      firstEditPagePath: PATH_NAMES.EDIT_DATE,
      hideEditDateTitle: true,
      hideGoBackButton: true,
    },
    selectDateTitle: 'Select a date',
    // eslint-disable-next-line react/prop-types
    subtitleComponent: ({ className }) => (
      <div className={className}>
        <p>Our appointments are carried out online so you can receive expert advice anywhere at a time that works for you.</p>
      </div>
    ),
    getSelectDateExternalPrevPath: envConfig => envConfig.services[services.NURSERY.name].landingPageUrl,
    AboutYou: {
      TimeSlot: {
        title: 'Your appointment time',
      },
    },
    ReviewForm: {
      hideShopDetails: true,
    },
    BookingReview: {
      hideShopDetails: true,
      displayPropertyAddress: true,
    },
    ReviewIntro: {
      title: 'Almost there',
      description: 'Please review your details before you complete your appointment booking.',
    },
  },
};
